import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '../../../../../reducers';
import { Subsidiary } from '../../../../models/subsidiary.model';
import { selectSubsidiaries } from '../drill-down.selectors';

@Component({
  selector: 'app-drill-down-subsidiaries',
  templateUrl: './subsidiaries.component.html',
  styleUrls: ['./subsidiaries.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class SubsidiariesComponent implements OnInit {
  subsidiaries$: Observable<Subsidiary[]>;

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.subsidiaries$ = this.store.pipe(select(selectSubsidiaries));
  }
}
